
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30800',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30800",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55332",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8348",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11804",
  "I18n": "static-7.1675",
  "quartz": "static-1.7474",
  "quartz-config": "static-1.1252",
  "quartz-core": "static-1.6693",
  "react-dlb": "static-1.89",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.937",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55319",
  "feedback-utils": "static-1.55323",
  "forms-embed-utils-lib": "static-1.4779",
  "forms-utils-lib": "static-1.13108",
  "foundations-assets": "static-1.5200",
  "foundations-components": "static-1.8510",
  "foundations-theming": "static-1.4790",
  "hub-http": "static-1.6529",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12111",
  "icons": "static-2.685",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4138",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.17036",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5565",
  "react-virtualized": "static-2.107",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.503",
  "tinymce-plugins": "static-1.58238",
  "transmute": "static-2.97",
  "ui-images": "static-2.1252",
  "UIComponents": "static-3.8750",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3630",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3751",
  "quartz-webpack": "static-1.3698",
  "foundations-theming-specialty": "static-1.2506",
  "property-description-translator": "static-1.4153",
  "HeadJS": "static-2.798",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3459",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4628",
  "jasmine-runner": "static-1.6766",
  "opentelemetry-fe-types": "static-1.86",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.882",
  "hubspotter-http": "static-1.4871",
  "mobile-manifest-mixins": "static-1.578",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.461",
  "quartz-auth": "static-1.1149",
  "quartz-head": "static-1.1139",
  "quartz-i18n": "static-1.1149",
  "quartz-routing": "static-1.904",
  "quartz-test": "static-1.1149",
  "quartz-tracking": "static-1.853",
  "trellis-components": "static-1.2693",
  "ui-fonts": "static-1.1066",
  "usage-tracker-container": "static-1.7627",
  "usage-tracker-core": "static-1.7487",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.206",
  "conversations-skeleton-state": "static-1.7562",
  "reference-resolvers": "static-1.8496",
  "sanitize-text": "static-1.8471",
  "PatternValidationJS": "static-1.3208",
  "ReduxMessenger": "static-2.10686",
  "outpost": "static-1.4469",
  "rpc-client-utils": "static-1.4981",
  "sanitize": "static-1.4787",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4779",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9739",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.72",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2674",
  "bend-plugin-foundations-theming": "static-1.3273",
  "foundations-theming-base": "static-1.3775",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.303",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9739",
  "atom": "static-1.5401",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8213",
  "ContentUtils": "static-1.69140",
  "data-token-picker": "static-1.16904",
  "file-manager-components": "static-1.24522",
  "FileManagerCore": "static-1.40021",
  "FileManagerLib": "static-1.40162",
  "frontend-preferences-client": "static-1.8236",
  "hub-http-contrib": "static-1.3354",
  "interframe": "static-3.5070",
  "layout-dnd-components": "static-1.12986",
  "layout-dnd-utils": "static-1.11961",
  "property-translator": "static-1.5710",
  "react-codemirror": "static-1.10956",
  "react-colorpicker": "static-2.10532",
  "reference-resolvers-lite": "static-1.8418",
  "rich-text-lib": "static-1.20321",
  "tinymce-data": "static-1.41209",
  "tinymce-themes": "static-1.57094",
  "ui-addon-emoji-picker": "static-1.10200",
  "ui-addon-sales-email": "static-1.5528",
  "ui-brand-identity-lib": "static-1.16521",
  "bender-build-tools": "static-1.3444",
  "opentelemetry-web": "static-1.13",
  "hub-http-shared-msw-handlers": "static-1.10636",
  "hubspotter-http-shared-msw-handlers": "static-1.10634",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1289",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.391",
  "chirp-fetch": "static-1.2209",
  "stylex-utils": "static-1.142",
  "chatspot-core": "static-1.23072",
  "copilot-toolkit": "static-1.11863",
  "customer-data-objects-ui-components": "static-1.13345",
  "data-fetching-client": "static-1.9971",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5073",
  "ui-addon-video-player": "static-1.9019",
  "ui-coaching-tips": "static-1.29325",
  "usage-tracker": "static-1.7637",
  "cms-field-types": "static-1.5130",
  "content-icons-ui": "static-1.2378",
  "integrations-lib": "static-1.17060",
  "customer-data-objects": "static-1.8008",
  "breeze-engine-lib": "static-1.1768",
  "immer": "static-1.101",
  "immerable": "static-1.4463",
  "ui-addon-iframeable": "static-1.9393",
  "video-components-external": "static-1.12164",
  "video-data-lib": "static-1.35822",
  "breeze-artifacts-sdk": "static-1.371",
  "audio-components": "static-1.6358",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29826",
  "FileManagerImages": "static-1.37673",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "ui-universal-auth": "static-1.9422",
  "urlinator": "static-1.4848",
  "video-components": "static-1.14166",
  "video-embed": "static-1.36656",
  "ts-schema": "static-1.4303",
  "ContentData": "static-1.69215",
  "layout-data-lib": "static-1.10286",
  "react-dnd-compat": "static-1.4931",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1859",
  "external-options-client-types": "static-1.4347",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7207",
  "hs-promise-utils": "static-1.5910",
  "inbound-db-properties-service-client": "static-1.4063",
  "NamespacedHubStyle": "static-2.9273",
  "apollo-dlb": "static-3.86",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "growth-onboarding-confetti": "static-1.3376",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11462",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5767",
  "magpie-types": "static-1.5227",
  "simple-logging-lib": "static-1.3366",
  "avatar-components": "static-1.2796",
  "customer-data-ui-utilities": "static-1.10145",
  "growth-onboarding-feedback-components": "static-1.6899",
  "flux-actions": "static-1.369",
  "hubspot-apollo-client": "static-1.5192",
  "integrations-error-boundary-lib": "static-1.14475",
  "integrations-tracking-lib": "static-1.5923",
  "laboratory-lib": "static-3.7468",
  "native-integrations-shared-strings": "static-1.8092",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10585",
  "unified-auth": "static-1.936",
  "breeze-engine-chat-components": "static-1.746",
  "breeze-engine-core": "static-1.1046",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "navigation-messaging": "static-1.8180",
  "apollo-link-hub-http": "static-2.4970",
  "content-media-composition-data-lib": "static-1.13264",
  "content-media-compositions": "static-2.17271",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19421",
  "foundations-components-legacy": "static-1.1535",
  "unified-auth-core-lib": "static-1.1218",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15592",
  "advanced-menus-lib": "static-1.12466",
  "ExportDialog": "static-6.10692",
  "ui-memberships-settings-lib": "static-1.34861",
  "conditional-properties-service-client": "static-1.4023",
  "crm-pipelines-api-client-types": "static-1.4356",
  "fdsr-migration-layer": "static-1.326",
  "framework-builder-read-service-client": "static-1.4229",
  "framework-data-schema-quick-fetch": "static-1.7112",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3917",
  "persist-promise": "static-1.4016",
  "foundations-components-test-utils": "static-1.5993",
  "reactive-lib": "static-1.1033",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.651",
  "universal-page-editor-lib": "static-1.3324",
  "adobe-sign-auth-lib": "static-1.479",
  "ads-unified-auth-lib": "static-1.1448",
  "generic-oauth-auth-lib": "static-1.64",
  "google-sheets-integration-lib": "static-1.1046",
  "microsoft-drive-auth-lib": "static-1.162",
  "surveymonkey-integration-lib": "static-1.505",
  "slack-ui-library": "static-1.10713",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4065",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15591",
  "simple-menus-lib": "static-1.17108",
  "settings-ui-lib": "static-1.12840",
  "crm-record-cards-service-types": "static-1.3795",
  "location-customization-utils-lib": "static-1.10116",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30800",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55332",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8348",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11804",
  "I18n": "/I18n/static-7.1675",
  "quartz": "/quartz/static-1.7474",
  "quartz-config": "/quartz-config/static-1.1252",
  "quartz-core": "/quartz-core/static-1.6693",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.937",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55319",
  "feedback-utils": "/feedback-utils/static-1.55323",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4779",
  "forms-utils-lib": "/forms-utils-lib/static-1.13108",
  "foundations-assets": "/foundations-assets/static-1.5200",
  "foundations-components": "/foundations-components/static-1.8510",
  "foundations-theming": "/foundations-theming/static-1.4790",
  "hub-http": "/hub-http/static-1.6529",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12111",
  "icons": "/icons/static-2.685",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4138",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.17036",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5565",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.503",
  "tinymce-plugins": "/tinymce-plugins/static-1.58238",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1252",
  "UIComponents": "/UIComponents/static-3.8750",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3630",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3751",
  "quartz-webpack": "/quartz-webpack/static-1.3698",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2506",
  "property-description-translator": "/property-description-translator/static-1.4153",
  "HeadJS": "/HeadJS/static-2.798",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3459",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4628",
  "jasmine-runner": "/jasmine-runner/static-1.6766",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.86",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.882",
  "hubspotter-http": "/hubspotter-http/static-1.4871",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.578",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.461",
  "quartz-auth": "/quartz-auth/static-1.1149",
  "quartz-head": "/quartz-head/static-1.1139",
  "quartz-i18n": "/quartz-i18n/static-1.1149",
  "quartz-routing": "/quartz-routing/static-1.904",
  "quartz-test": "/quartz-test/static-1.1149",
  "quartz-tracking": "/quartz-tracking/static-1.853",
  "trellis-components": "/trellis-components/static-1.2693",
  "ui-fonts": "/ui-fonts/static-1.1066",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.206",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7562",
  "reference-resolvers": "/reference-resolvers/static-1.8496",
  "sanitize-text": "/sanitize-text/static-1.8471",
  "PatternValidationJS": "/PatternValidationJS/static-1.3208",
  "ReduxMessenger": "/ReduxMessenger/static-2.10686",
  "outpost": "/outpost/static-1.4469",
  "rpc-client-utils": "/rpc-client-utils/static-1.4981",
  "sanitize": "/sanitize/static-1.4787",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4779",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9739",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2674",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3273",
  "foundations-theming-base": "/foundations-theming-base/static-1.3775",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.303",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9739",
  "atom": "/atom/static-1.5401",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8213",
  "ContentUtils": "/ContentUtils/static-1.69140",
  "data-token-picker": "/data-token-picker/static-1.16904",
  "file-manager-components": "/file-manager-components/static-1.24522",
  "FileManagerCore": "/FileManagerCore/static-1.40021",
  "FileManagerLib": "/FileManagerLib/static-1.40162",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8236",
  "hub-http-contrib": "/hub-http-contrib/static-1.3354",
  "interframe": "/interframe/static-3.5070",
  "layout-dnd-components": "/layout-dnd-components/static-1.12986",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11961",
  "property-translator": "/property-translator/static-1.5710",
  "react-codemirror": "/react-codemirror/static-1.10956",
  "react-colorpicker": "/react-colorpicker/static-2.10532",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8418",
  "rich-text-lib": "/rich-text-lib/static-1.20321",
  "tinymce-data": "/tinymce-data/static-1.41209",
  "tinymce-themes": "/tinymce-themes/static-1.57094",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10200",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5528",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16521",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10636",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10634",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1289",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.391",
  "chirp-fetch": "/chirp-fetch/static-1.2209",
  "stylex-utils": "/stylex-utils/static-1.142",
  "chatspot-core": "/chatspot-core/static-1.23072",
  "copilot-toolkit": "/copilot-toolkit/static-1.11863",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13345",
  "data-fetching-client": "/data-fetching-client/static-1.9971",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5073",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9019",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29325",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "cms-field-types": "/cms-field-types/static-1.5130",
  "content-icons-ui": "/content-icons-ui/static-1.2378",
  "integrations-lib": "/integrations-lib/static-1.17060",
  "customer-data-objects": "/customer-data-objects/static-1.8008",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1768",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4463",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9393",
  "video-components-external": "/video-components-external/static-1.12164",
  "video-data-lib": "/video-data-lib/static-1.35822",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.371",
  "audio-components": "/audio-components/static-1.6358",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29826",
  "FileManagerImages": "/FileManagerImages/static-1.37673",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "ui-universal-auth": "/ui-universal-auth/static-1.9422",
  "urlinator": "/urlinator/static-1.4848",
  "video-components": "/video-components/static-1.14166",
  "video-embed": "/video-embed/static-1.36656",
  "ts-schema": "/ts-schema/static-1.4303",
  "ContentData": "/ContentData/static-1.69215",
  "layout-data-lib": "/layout-data-lib/static-1.10286",
  "react-dnd-compat": "/react-dnd-compat/static-1.4931",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1859",
  "external-options-client-types": "/external-options-client-types/static-1.4347",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7207",
  "hs-promise-utils": "/hs-promise-utils/static-1.5910",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4063",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9273",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3376",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11462",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5767",
  "magpie-types": "/magpie-types/static-1.5227",
  "simple-logging-lib": "/simple-logging-lib/static-1.3366",
  "avatar-components": "/avatar-components/static-1.2796",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10145",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6899",
  "flux-actions": "/flux-actions/static-1.369",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5192",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14475",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5923",
  "laboratory-lib": "/laboratory-lib/static-3.7468",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8092",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10585",
  "unified-auth": "/unified-auth/static-1.936",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.746",
  "breeze-engine-core": "/breeze-engine-core/static-1.1046",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "navigation-messaging": "/navigation-messaging/static-1.8180",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4970",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13264",
  "content-media-compositions": "/content-media-compositions/static-2.17271",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19421",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1535",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1218",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15592",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12466",
  "ExportDialog": "/ExportDialog/static-6.10692",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34861",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4023",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4356",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.326",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4229",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7112",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3917",
  "persist-promise": "/persist-promise/static-1.4016",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5993",
  "reactive-lib": "/reactive-lib/static-1.1033",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.651",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3324",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.479",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1448",
  "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.64",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1046",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.162",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.505",
  "slack-ui-library": "/slack-ui-library/static-1.10713",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4065",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15591",
  "simple-menus-lib": "/simple-menus-lib/static-1.17108",
  "settings-ui-lib": "/settings-ui-lib/static-1.12840",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3795",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10116",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
